import React, {Component} from "react";
//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import AutoCompleteClinicalNotes from "components/Search/AutoCompleteClinicalNotes.jsx";
import AutoCompleteMedication from "components/Search/AutoCompleteMedication.jsx";
import AutoCompletePrescriptionTemplate from "components/Search/AutoCompletePrescriptionTemplate.jsx";
import Slide from "@material-ui/core/Slide";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

// @material-ui/core components

import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import Grid from '@material-ui/core/Grid';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Card from "components/Card/Card.jsx";
import TextField from '@material-ui/core/TextField';
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber,
    getDateConverter,
    currentDate,
    isClinicMasterOrClinic,
    getClinicUserId,
    clinicmaster_id,
    dashboardRouter,
    timing
} from '../../util/globalHelper';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {
    saveSearchPrescription
} from '../../redux/global'
// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import Loader from '../../components/Loader'
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import 'react-tagsinput/react-tagsinput.css'
import Datetime from "react-datetime";
import NumberFormat from 'react-number-format';

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);

        }
    }
    return arr;
}

class CreatePrescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            save_template: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            doctorList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            autoCompleteValue: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            clinicmaster_id: "",
            doctor_id: "",
            clinic_id: "",
            patient: null,
            clinicsData: null,
            editorState: EditorState.createEmpty(),
            ref_by: "",
            age: "",
            remarks: "",
            ref_byState: "",
            remarksState: "",
            ageState: "",
            clinicDetail: null,
            secondaryNumber: [""],
            secondaryNumberState: [],
            investigation: [{name: "", instruction: ""}],
            medication: [{name: "", dosage: "", frequency: "", instruction: ""}],
            gender: "",
            templates: [],
            templatesPres: [],
            selectedPill: null,
            Complaints: [""],
            Observation: [""],
            Diagnosis: [""],
            pulse: "",
            weight: "",
            bloodPressure: "",
            temperature: "",
            rate: "",
            duration: [""],
            durationType: ["days"],
            selectTemplate: 0,
            previewModal: false,
            classicModal: false,
            followupDate: ""

        };
        this.typeClick = this.typeClick.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.setReportTitle = this.setReportTitle.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.handleChangeSecondayNumber = this.handleChangeSecondayNumber.bind(this);
        this.changeSecondaryNumbers = this.changeSecondaryNumbers.bind(this);
        this.handleChangeInvestigation = this.handleChangeInvestigation.bind(this);
        this.handleChangeMedication = this.handleChangeMedication.bind(this);
        this.handleChangeFrequency = this.handleChangeFrequency.bind(this);
        this.saveMedication = this.saveMedication.bind(this);
        this.saveInvestigation = this.saveInvestigation.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.GetTemplatesAlert = this.GetTemplatesAlert.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);
        this.setNotesValue = this.setNotesValue.bind(this);
        this.onSelectDuration = this.onSelectDuration.bind(this);
        this.onSelectDurationType = this.onSelectDurationType.bind(this);
        this.newNoteAdd = this.newNoteAdd.bind(this);
        this.addMedication = this.addMedication.bind(this);
        this.addInvestigation = this.addInvestigation.bind(this);
        this.setTemplate = this.setTemplate.bind(this);

    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    componentWillReceiveProps(nextProps) {
        // if (nextProps.searchPrescription !== this.props.searchPrescription && nextProps.searchPrescription !== null) {
        //     this.setState({alert: null}, () => {
        //         this.GetTemplatesAlert();
        //     });
        // }
    }


    onEditorStateChange(editorState) {
        this.setState({
            editorState,
        });
    };

    onChangeText(e, name) {
        this.setState({[name]: e.target.value})
    }

    hideAlert() {
        this.setState({alert: null})
    }

    setTemplate() {
        let data = this.state.templatesPres[this.state.selectTemplate];
        this.setState({
            "medication": data.medicines ? data.medicines.map(a => {
                return {
                    name: a.name,
                    dosage: a.dosage.split(" ")[0],
                    frequency: a.frequency,
                    instruction: a.instruction
                }
            }) : [{name: "", dosage: "", frequency: "", instruction: ""}],
            "durationType": data.medicines ? data.medicines.map(item => {
                return "days"
            }) : [""],
            "investigation": data.investigation ? data.investigation : [{name: "", instruction: ""}],
            "Complaints": data.clinical_notes && data.clinical_notes.complaint ? [data.clinical_notes.complaint] : [""],
            "Observation": data.clinical_notes && data.clinical_notes.observations ? [data.clinical_notes.observations] : [""],
            "Diagnosis": data.clinical_notes && data.clinical_notes.diagnosis ? [data.clinical_notes.diagnosis] : [""],
            "alert": null
        })
    }

    handleChangeDate(event) {
        this.setState({
            followupDate: (event).format('YYYY-MM-DD')
        })
    }

    CreateAlert() {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Vital Signs"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <form noValidate autoComplete="off" style={{padding: '0px 50px '}}>
                            <GridContainer>
                                <TextField
                                    id="standard-name"
                                    label="Weight(kg)"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'weight')}
                                    margin="normal"
                                />
                                <TextField
                                    id="standard-name"
                                    label="Blood Pressure(mmHg)"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'bloodPressure')}
                                    margin="normal"
                                />

                                <TextField
                                    id="standard-name"
                                    label="Pulse(Hearts beats/min)"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'pulse')}
                                    margin="normal"
                                />

                                <TextField
                                    id="standard-name"
                                    label="Temprature(F)"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'temperature')}
                                    margin="normal"
                                />

                                <TextField
                                    id="standard-name"
                                    label="Rate(Breaths/min)"
                                    fullWidth
                                    onChange={e => this.onChangeText(e, 'rate')}
                                    margin="normal"
                                /></GridContainer>
                        </form>
                    </DialogActions>
                    <DialogActions style={{margin: '8px auto'}}>

                        <GridContainer> <Button color="danger" onClick={() => {
                        }}>
                            Save
                        </Button>
                            <Button onClick={this.hideAlert}>
                                Cancel
                            </Button></GridContainer>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    GetTemplatesAlert() {
        const globalThis = this;
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    maxWidth="lg"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Select Prescripttion Templates"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto', width: '900px'}}>
                        <GridContainer style={{padding: '20px'}}>
                            <Grid item xs={4}>
                                <AutoCompletePrescriptionTemplate clinic_id={globalThis.state.clinic_id}
                                                                  clinic_master_id={globalThis.state.clinicmaster_id}
                                                                  setNotesValue={globalThis.setNotesValue}
                                                                  getReportTitleSuggestionValue={globalThis.getReportTitleSuggestionValue}/>
                                {globalThis.state.templatesPres.map((item, index) => {
                                    return <ListItem component="div"
                                                     onClick={() => {
                                                         globalThis.setState({
                                                             selectTemplate: index
                                                         });
                                                         this.props.saveSearchPrescription(Math.random())
                                                     }}
                                                     style={globalThis.state.selectTemplate === index ? {
                                                         padding: '10px',
                                                         margin: '0',
                                                         background: '#39abc1',
                                                         color: 'white'
                                                     } : {
                                                         padding: '10px',
                                                         margin: '0',
                                                         background: '#fff',
                                                         color: 'black'
                                                     }} key={index}>
                                        <div style={{padding: "5px"}}>
                                            <GridContainer key={Math.random()}>
                                                <GridItem xs={12}>
                                                    <h4>{item.remark !== "" ? item.remark : "No Remark"}</h4>
                                                    <p>{item.created_at ? getDateConverter(item.created_at) : null}</p>
                                                </GridItem>
                                            </GridContainer>
                                        </div>
                                    </ListItem>
                                })}
                            </Grid>
                            <Grid item xs={8}>
                                <Card component="div" style={{margin: '10px'}}>
                                    <div style={{padding: "5px"}}>
                                        <GridContainer key={Math.random()}>
                                            <GridItem xs={12}>
                                                <GridItem>
                                                    <h4><strong>Clinical Notes</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <div>
                                                        <b>Complaints:</b>{globalThis.state.templatesPres[globalThis.state.selectTemplate] && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.complaint ? globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.complaint : ""}<br/>
                                                        <b>
                                                            Observation:</b>{globalThis.state.templatesPres[globalThis.state.selectTemplate] && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.observations ? globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.observations : ""}<br/>
                                                        <b>Diagnosis:</b>{globalThis.state.templatesPres[globalThis.state.selectTemplate] && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes && globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.diagnosis ? globalThis.state.templatesPres[globalThis.state.selectTemplate].clinical_notes.diagnosis : ""}
                                                    </div>
                                                </GridItem>
                                                <GridItem>
                                                    <h4><strong>Investigation</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <div>{globalThis.state.templatesPres[globalThis.state.selectTemplate].investigation.map(item => {
                                                        return <div key={Math.random()}>{item.name}</div>
                                                    })}</div>
                                                </GridItem>
                                                <GridItem>
                                                    <h4><strong>Prescription</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <div>{globalThis.state.templatesPres[globalThis.state.selectTemplate].medicines.map(item => {
                                                        return <div key={Math.random()}>{item.name}</div>
                                                    })}</div>
                                                </GridItem>
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                </Card>
                            </Grid>

                        </GridContainer>
                    </DialogActions>
                    <DialogActions style={{margin: '8px auto'}}>

                        <GridContainer> <Button color="danger" onClick={() => {
                            this.setTemplate()
                        }}>
                            Select
                        </Button>
                            <Button onClick={this.hideAlert}>
                                Cancel
                            </Button></GridContainer>
                    </DialogActions>
                </Dialog>
            )
        });
    }


    handleImageUrl(url) {
        var reportCount = this.state.report_link.length > 0 ? this.state.report_link.length : "";
        this.setState({
            // imageurl: url,
            report_link: this.state.report_link.concat({
                "link": url,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`
            })
        }, () => {
            // this.setState({imageurl: ''})
        });
    }

    removeReport(url) {
        this.setState({report_link: this.state.report_link.splice(this.state.report_link.indexOf(this.state.report_link.find(item => item.link === url)), 1)})
    }

    changeExistingReport(url, preUrl) {
        let objIndex = this.state.report_link.length > 0 ? this.state.report_link.findIndex((obj => obj.link === preUrl)) : null;
        if (this.state.report_link.length > 0) {
            this.state.report_link[objIndex].link = url
        }
    }

    getSuggestionValue = (suggestion) => {
        // this.setState({
        //     // clickedId: suggestion._id,
        //     notes: suggestion,
        //     name: suggestion.text,
        //     // nameState: 'success',
        //     // contactNumber: suggestion.user_id.contact,
        //     // contactNumberState: 'success',
        //     // email: suggestion.user_id.email,
        //     // emailState: 'success',
        //     // age: suggestion.user_id.gender && suggestion.user_id.age !== "" ? suggestion.user_id.age : "",
        //     // gender: suggestion.user_id.gender && suggestion.user_id.gender !== "" ? suggestion.user_id.gender === "male" ? "M" : "F" : ""
        // });
        return suggestion.text

    }


    getSuggestionPatientValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name,
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
            age: suggestion.user_id.gender && suggestion.user_id.age !== "" ? suggestion.user_id.age : "",
            gender: suggestion.user_id.gender && suggestion.user_id.gender !== "" ? suggestion.user_id.gender === "male" ? "M" : "F" : ""
        });
        return suggestion.user_id.contact

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID)
        var postBody = {
            "text": ""
        };
        api.getPrescriptionTemplates(postBody).then((result) => {
            this.setState({templatesPres: result ? result.data.data : []});
        }).catch((err) => {
        });
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({
            clinicMasterList: {},
            clinicmaster_id: clinicmaster_id(),
            clinic_id: getClinicUserId()
        });
        var postBody = {
            "clinic_master_id": clinicmaster_id(),
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name, nameState: 'success',
                        autoCompleteValue: this.state.patientDetail.user_id.contact,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        contactNumberState: 'success',
                        email: this.state.patientDetail.user_id.email,
                        emailState: 'success',
                    })
                })
            })
        }
        ;
        // api.getAllDoctors().then(json => {
        //     this.setState({doctorList: json.data.data})
        // });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        if (e.target.name === "clinic_id") {
            api.getClinicById(e.target.value, {}).then(json => {
                this.setState({clinicDetail: json.data.data}, () => {
                    if (this.state.clinicDetail !== null && this.state.clinicDetail.clinic_doctors && this.state.clinicDetail.clinic_doctors.length === 1) {
                        this.setState({secondaryNumber: [this.state.clinicDetail.clinic_doctors[0].user_id.name]})
                    }
                });
            })
        }
    }

    setReportTitle(value) {
        this.setState({autoCompleteReportValue: value})
    }

    getReportTitleSuggestionValue = (suggestion) => {
        this.setState({
            report: suggestion,
            templatesPres: [suggestion],
            reportTitle: suggestion.remark,
            alert: null
            // simpleSelect: suggestion.type,
            // templates: suggestion.templates
            // description: suggestion.description,
            // descriptionState: 'success',
            // editorState: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(suggestion.html.replace(/10px;/gi, "12px"))).contentBlocks)),
        }, () => {
            // this.GetTemplatesAlert();
        });
        return suggestion.remark

    };

    componentWillUnmount() {
        this.setState({
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            gender: ""
        })

    }

    setNotesValue(type, value, index) {
        this.state[type][index] = value;
        this.setState({[type]: this.state[type]});
    }

    newNoteAdd(type) {
        let a = [""];
        let b = this.state[type].concat(a);
        this.setState({[type]: b}, () => {
            document.getElementById(type + (b.length - 1).toString()).focus();
        });
    }

    render() {
        const {classes} = this.props;
        const {clinicLis, clinicsData, clinicMasterList, editorState} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && (this.state.clinicsData[0] ? this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id : true) || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList)
            return (
                <div>
                    <GridContainer>
                        {this.state.alert}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Create Prescription</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            {isClinicMasterOrClinic() === "" ?
                                                <GridItem xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicMasterList.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <br/>
                                                </GridItem> : null}
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
                                                <GridItem xs={12} sm={6} className="centerDiv">

                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem
                                                                    disabled
                                                                >
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.length > 0 ? clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                }) : null}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem> : null}
                                            <GridItem xs={12} sm={6}>

                                                {this.props.id.match.params.patientID ? <CustomInput
                                                        labelText=" Phone Number"
                                                        success={this.state.contactNumberState === "success"}
                                                        error={this.state.contactNumberState === "error"}
                                                        id="url"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                            value: this.state.contactNumber,

                                                        }}
                                                    /> :
                                                    <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                     name={this.state.name}
                                                                     getSuggestionValue={this.getSuggestionPatientValue}/>}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Name"
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name"),
                                                        value: this.state.name,

                                                    }}
                                                />

                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Email"
                                                    success={this.state.emailState === "success"}
                                                    error={this.state.emailState === "error"}
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "email", "email"),
                                                        value: this.state.email,

                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6} style={{marginTop: '10px'}}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="simple-select"
                                                        className={classes.selectLabel}>
                                                        Gender
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.gender}
                                                        onChange={e => this.onChangeSelect(e)}
                                                        inputProps={{name: "gender", id: "gender"}}>
                                                        <MenuItem
                                                            disabled={true}
                                                            classes={{
                                                                root: classes.selectMenuItem,
                                                                selected: classes.selectMenuItemSelected
                                                            }}>
                                                            Select Gender
                                                        </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="M">
                                                            Male </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="F">
                                                            Female </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>

                                                <CustomInput
                                                    labelText="Age"
                                                    success={this.state.ageState === "success"}
                                                    error={this.state.ageState === "error"}
                                                    id="age"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "age", "novalidation"),
                                                        value: this.state.age,

                                                    }}
                                                />

                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Ref By"
                                                    success={this.state.ref_byState === "success"}
                                                    error={this.state.ref_byState === "error"}
                                                    id="ref_by"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: false
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "ref_by", "novalidation"),
                                                        value: this.state.ref_by,
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.checkedA}
                                                            onChange={this.handleChange("checkedA")}
                                                            value="checkedA"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="No Payment Dues"
                                                />
                                            </GridItem>

                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                {this.state.templates !== [] && this.state.templates.length > 0 ? this.state.templates.map((item, index) => {
                                                    return <a key={index}
                                                              href="#" onClick={() => {
                                                        this.setState({
                                                            description: item.description,
                                                            descriptionState: 'success',
                                                            editorState: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(item.html.replace(/10px;/gi, "12px"))).contentBlocks)),
                                                            selectedPill: index
                                                        })
                                                    }}>  {this.state.selectedPill === index ?
                                                        <Button color="primary" round className={classes.marginRight}>
                                                            {item.remark && item.remark !== "" ? item.remark : "No Remark"}
                                                        </Button> :
                                                        <Button color="info" round className={classes.marginRight}>
                                                            {item.remark && item.remark !== "" ? item.remark : "No Remark"}
                                                        </Button>}</a>
                                                }) : null}
                                            </GridItem>
                                        </GridContainer>
                                        <h3 style={{marginBottom: '30px'}}>Clinical Notes <Button
                                            style={{float: 'right'}} color="warning"
                                            onClick={() => this.handleClickOpen("classicModal")}

                                        >
                                            View Templates
                                        </Button><Button
                                            style={{float: 'right'}} color="warning"
                                            onClick={this.CreateAlert}>
                                            Vitals
                                        </Button>
                                        </h3>
                                        <div id="clinical_notess">
                                            <GridItem id="notes">
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{
                                                                   justifyContent: 'center',
                                                                   textAlign: 'center',
                                                                   marginBottom: '20px'
                                                               }}>
                                                    <ExpansionPanel
                                                        className="width-full" defaultExpanded>
                                                        <ExpansionPanelSummary
                                                            expandIcon={<ExpandMoreIcon/>}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header">
                                                            <Typography
                                                                className={classes.heading}>Complaints</Typography>
                                                        </ExpansionPanelSummary>
                                                        {this.state.Complaints.map((a, index) => {
                                                            return <ExpansionPanelDetails
                                                                style={{padding: '0 24px'}}>
                                                                <Typography className="width-full">
                                                                    <AutoCompleteClinicalNotes
                                                                        clinic_id={this.state.clinic_id}
                                                                        clinic_master_id={this.state.clinicmaster_id}
                                                                        name={"Complaints"}
                                                                        type="Complaints"
                                                                        id={"Complaints" + index}
                                                                        value={a}
                                                                        index={index}
                                                                        newNoteAdd={this.newNoteAdd}
                                                                        setNotesValue={this.setNotesValue}
                                                                        getSuggestionValue={this.getSuggestionValue}/>
                                                                    <br/>
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        })}}
                                                    </ExpansionPanel>
                                                </GridContainer>
                                                <br/>
                                            </GridItem>
                                            <GridItem id="notes">
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{
                                                                   justifyContent: 'center',
                                                                   textAlign: 'center',
                                                                   marginBottom: '20px'
                                                               }}>
                                                    <ExpansionPanel className="width-full" defaultExpanded>
                                                        <ExpansionPanelSummary
                                                            expandIcon={<ExpandMoreIcon/>}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header">
                                                            <Typography
                                                                className={classes.heading}>Observations</Typography>
                                                        </ExpansionPanelSummary>
                                                        {this.state.Observation.map((a, index) => {
                                                            return <ExpansionPanelDetails
                                                                style={{padding: '0px 24px 15px'}}>
                                                                <Typography className="width-full">
                                                                    <AutoCompleteClinicalNotes
                                                                        clinic_id={this.state.clinic_id}
                                                                        clinic_master_id={this.state.clinicmaster_id}
                                                                        name={"Observation"}
                                                                        type="Observation"
                                                                        id={"Observation" + index}

                                                                        value={a}
                                                                        newNoteAdd={this.newNoteAdd}
                                                                        index={index}
                                                                        setNotesValue={this.setNotesValue}
                                                                        getSuggestionValue={this.getSuggestionValue}/>
                                                                    {/*<TextField*/}
                                                                    {/*id="standard-multiline-flexible"*/}
                                                                    {/*label="Observation"*/}
                                                                    {/*multiline*/}
                                                                    {/*rows="4"*/}
                                                                    {/*value={this.state.observation}*/}
                                                                    {/*onChange={e => this.onChangeText(e, "observation")}*/}
                                                                    {/*className={classes.textField + " width-full"}*/}
                                                                    {/*margin="normal"*/}
                                                                    {/*/>*/}
                                                                </Typography> </ExpansionPanelDetails>

                                                        })}}
                                                    </ExpansionPanel>
                                                </GridContainer>
                                                <br/>
                                            </GridItem>
                                            <GridItem id="notes">
                                                <GridContainer className={classes.justifyContentCenter} style={{
                                                    justifyContent: 'center', textAlign: 'center', marginBottom: '20px'
                                                }}>
                                                    <ExpansionPanel className="width-full" defaultExpanded>
                                                        <ExpansionPanelSummary
                                                            expandIcon={<ExpandMoreIcon/>}
                                                            aria-controls="panel1a-content"
                                                            id="panel1a-header">
                                                            <Typography
                                                                className={classes.heading}>Diagnosis</Typography>
                                                        </ExpansionPanelSummary>
                                                        {this.state.Diagnosis.map((a, index) => {
                                                            return <ExpansionPanelDetails
                                                                style={{padding: '0px 24px 15px'}}>
                                                                <Typography className="width-full">
                                                                    <AutoCompleteClinicalNotes
                                                                        clinic_id={this.state.clinic_id}
                                                                        clinic_master_id={this.state.clinicmaster_id}
                                                                        name={"Diagnosis"}
                                                                        type="Diagnosis"
                                                                        id={"Diagnosis" + index}
                                                                        value={a}
                                                                        newNoteAdd={this.newNoteAdd}
                                                                        index={index}
                                                                        setNotesValue={this.setNotesValue}
                                                                        getSuggestionValue={this.getSuggestionValue}/>
                                                                    {/*<TextField*/}
                                                                    {/*id="standard-multiline-flexible"*/}
                                                                    {/*label="Daignosis"*/}
                                                                    {/*multiline*/}
                                                                    {/*rows="4"*/}
                                                                    {/*value={this.state.daignosis}*/}
                                                                    {/*onChange={e => this.onChangeText(e, "daignosis")}*/}
                                                                    {/*className={classes.textField + " width-full"}*/}
                                                                    {/*margin="normal"*/}
                                                                    {/*/>*/}
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        })}}
                                                    </ExpansionPanel>
                                                </GridContainer>
                                                <br/>
                                            </GridItem>
                                        </div>
                                        <div id="clinical_medi"><h3>Prescription</h3>
                                            <GridItem>
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{
                                                                   justifyContent: 'center',
                                                                   textAlign: 'center',
                                                                   marginBottom: '20px'
                                                               }}>
                                                    {this.state.investigation.length > 0 ?
                                                        <ExpansionPanel className="width-full" defaultExpanded>
                                                            <ExpansionPanelSummary
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header">
                                                                <Typography
                                                                    className={classes.heading}>Investigation</Typography>
                                                            </ExpansionPanelSummary>
                                                            <ExpansionPanelDetails>
                                                                <Typography className="width-full" defaultExpanded>
                                                                    {this.state.investigation.map((item, index) => {
                                                                        return <div
                                                                            className="width-full list-inline displayInline"
                                                                            key={"investigation" + index}>
                                                                            <GridItem xs={12} sm={6}
                                                                                      style={{paddingTop: '33px'}}>
                                                                                <AutoCompleteMedication
                                                                                    clinic_id={this.state.clinic_id}
                                                                                    clinic_master_id={this.state.clinicmaster_id}
                                                                                    name={"Name"}
                                                                                    type="Investigation"
                                                                                    nameKey="name"
                                                                                    index={index}
                                                                                    id={"Investigation" + index}
                                                                                    value={item.name}
                                                                                    addInvestigation={this.addInvestigation}
                                                                                    saveMedicationInvestigation={this.saveInvestigation}
                                                                                    onChange={this.handleChangeInvestigation}
                                                                                    getSuggestionValue={this.getSuggestionValue}/>
                                                                                {/*<TextField*/}
                                                                                {/*required*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Name"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.name}*/}
                                                                                {/*onChange={e => this.handleChangeInvestigation(e, 'name', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={6}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Instruction"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.instruction}
                                                                                    onChange={e => this.handleChangeInvestigation(e, 'instruction', index)}
                                                                                    margin="normal"
                                                                                /></GridItem>
                                                                        </div>
                                                                    })}
                                                                    <GridItem xs={12} sm={6} md={3}>
                                                                        <Button color="warning"
                                                                                onClick={(e) => this.addInvestigation(e)}>Add
                                                                            Investigation
                                                                        </Button></GridItem>
                                                                    <GridItem xs={12} sm={6}>
                                                                    </GridItem>
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        </ExpansionPanel> :
                                                        <ExpansionPanel className="width-full" defaultExpanded>
                                                            <ExpansionPanelSummary
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header">
                                                                <Typography
                                                                    className={classes.heading}>Investigation</Typography>
                                                            </ExpansionPanelSummary>
                                                            <ExpansionPanelDetails>
                                                                <Typography className="width-full">
                                                                    {this.state.investigation.map((item, index) => {
                                                                        return <div
                                                                            className="width-full list-inline displayInline"
                                                                            key={"investigation" + index}>
                                                                            <GridItem xs={12} sm={12}>
                                                                                <AutoCompleteMedication
                                                                                    clinic_id={this.state.clinic_id}
                                                                                    clinic_master_id={this.state.clinicmaster_id}
                                                                                    name={"Name"}
                                                                                    type="Investigation"
                                                                                    nameKey="name"
                                                                                    index={index}
                                                                                    id={"Investigation" + index}
                                                                                    value={item.name}
                                                                                    addInvestigation={this.addInvestigation}
                                                                                    saveMedicationInvestigation={this.saveInvestigation}
                                                                                    onChange={this.handleChangeInvestigation}
                                                                                    getSuggestionValue={this.getSuggestionValue}/>
                                                                                {/*<TextField*/}
                                                                                {/*required*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Name"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.name}*/}
                                                                                {/*onChange={e => this.handleChangeInvestigation(e, 'name', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={12}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Instruction"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.instruction}
                                                                                    onChange={e => this.handleChangeInvestigation(e, 'instruction', index)}
                                                                                    margin="normal"
                                                                                /></GridItem>
                                                                        </div>
                                                                    })}
                                                                    <GridItem xs={12} sm={6} md={3}>
                                                                        <Button color="warning"
                                                                                onClick={(e) => this.addInvestigation(e)}>Add
                                                                            Investigation
                                                                        </Button></GridItem>
                                                                    <GridItem xs={12} sm={6}>
                                                                    </GridItem>
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        </ExpansionPanel>}
                                                </GridContainer>
                                                <br/>
                                            </GridItem>
                                            <GridItem>
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{
                                                                   justifyContent: 'center',
                                                                   textAlign: 'center',
                                                                   marginBottom: '20px'
                                                               }}>
                                                    {this.state.medication.length > 0 ?
                                                        <ExpansionPanel className="width-full" defaultExpanded>
                                                            <ExpansionPanelSummary
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header">
                                                                <Typography
                                                                    className={classes.heading}>Medication</Typography>
                                                            </ExpansionPanelSummary>
                                                            <ExpansionPanelDetails>
                                                                <Typography className="width-full">
                                                                    {this.state.medication.map((item, index) => {
                                                                        return <div
                                                                            className="width-full list-inline displayInline"
                                                                            key={"medication" + index}>
                                                                            <GridItem xs={12} sm={12} md={4}>
                                                                                {/*<TextField*/}
                                                                                {/*required*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Name"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.name}*/}
                                                                                {/*onChange={e => this.handleChangeMedication(e, 'name', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                                <AutoCompleteMedication
                                                                                    clinic_id={this.state.clinic_id}
                                                                                    clinic_master_id={this.state.clinicmaster_id}
                                                                                    name={"Medicine"}
                                                                                    type="Medication"
                                                                                    nameKey="name"
                                                                                    index={index}
                                                                                    value={item.name}
                                                                                    id={"Medication" + index}
                                                                                    addMedication={this.addMedication}
                                                                                    saveMedicationInvestigation={this.saveMedication}
                                                                                    onChange={this.handleChangeMedication}
                                                                                    getSuggestionValue={this.getSuggestionValue}/>
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={12} md={1}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Dosage"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.dosage}
                                                                                    onChange={e => this.handleChangeMedication(e, 'dosage', index)}
                                                                                    margin="normal"
                                                                                /> </GridItem>
                                                                            <GridItem xs={12} sm={12} md={1}
                                                                                      style={{marginTop: '40px'}}>
                                                                                <a href="#"
                                                                                   onClick={() => this.onSelectDurationType('durationType', index)}><span>{this.state.durationType[index]}</span></a>
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={12} md={3}>
                                                                                {/*<TextField*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Frequency"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.frequency}*/}
                                                                                {/*onChange={e => this.handleChangeMedication(e, 'frequency', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                                <NumberFormat
                                                                                    onValueChange={(values) => {
                                                                                        const {formattedValue, value} = values;
                                                                                        // formattedValue = $2,223
                                                                                        // value ie, 2223
                                                                                        this.handleChangeFrequency(formattedValue, 'frequency', index);
                                                                                    }} style={{
                                                                                    marginTop: '40px',
                                                                                    textAlign: 'center',
                                                                                    border: '0',
                                                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.44)'
                                                                                }}
                                                                                    placeholder="0-0-0"
                                                                                    format="#-#-#" mask="_"/>
                                                                            </GridItem>
                                                                            {/*<GridItem xs={12} sm={12} md={1}>*/}
                                                                            {/*<TextField*/}
                                                                            {/*id="standard-name"*/}
                                                                            {/*label="0"*/}
                                                                            {/*className={classes.textField + " width-full"}*/}
                                                                            {/*value={item.dosage}*/}
                                                                            {/*onChange={e => this.handleChangeMedication(e, 'dosage', index)}*/}
                                                                            {/*margin="normal"*/}
                                                                            {/*/></GridItem>*/}
                                                                            {/*<GridItem xs={12} sm={12} md={1}>*/}

                                                                            {/*<TextField*/}
                                                                            {/*id="standard-name"*/}
                                                                            {/*label="0"*/}
                                                                            {/*className={classes.textField + " width-full"}*/}
                                                                            {/*value={item.dosage}*/}
                                                                            {/*onChange={e => this.handleChangeMedication(e, 'dosage', index)}*/}
                                                                            {/*margin="normal"*/}
                                                                            {/*/>*/}
                                                                            {/*<InputLabel*/}
                                                                            {/*htmlFor="frequency">Frequency</InputLabel>*/}
                                                                            {/*<Select*/}
                                                                            {/*value={item.frequency}*/}
                                                                            {/*onChange={e => this.handleChangeMedication(e, 'frequency', index)}*/}
                                                                            {/*inputProps={{*/}
                                                                            {/*name: 'frequency',*/}
                                                                            {/*id: 'frequency',*/}
                                                                            {/*}}>*/}
                                                                            {/*<MenuItem value={"1-0-1"}>twice*/}
                                                                            {/*daily</MenuItem>*/}
                                                                            {/*<MenuItem value={"1-1-1"}>three*/}
                                                                            {/*times a*/}
                                                                            {/*day</MenuItem>*/}
                                                                            {/*<MenuItem value={"1-1-1-1"}>four*/}
                                                                            {/*times a*/}
                                                                            {/*day</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"every four hours"}>every*/}
                                                                            {/*four hours</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"every 2 hours"}>every*/}
                                                                            {/*2 hours</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"every other hour"}>every*/}
                                                                            {/*other hour</MenuItem>*/}
                                                                            {/*<MenuItem value={"every day"}>every*/}
                                                                            {/*day</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"every other day"}>every*/}
                                                                            {/*other day</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"three times a week"}>three*/}
                                                                            {/*times a week</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"immediately"}>immediately</MenuItem>*/}
                                                                            {/*<MenuItem value={"as needed"}>as*/}
                                                                            {/*needed</MenuItem>*/}
                                                                            {/*<MenuItem value={"once a week"}>once*/}
                                                                            {/*a*/}
                                                                            {/*week</MenuItem>*/}
                                                                            {/*<MenuItem*/}
                                                                            {/*value={"twice a week"}>twice*/}
                                                                            {/*a*/}
                                                                            {/*week</MenuItem>*/}
                                                                            {/*</Select>*/}
                                                                            {/*</FormControl>*/}
                                                                            {/*<TextField*/}
                                                                            {/*id="standard-name"*/}
                                                                            {/*label="Frequency"*/}
                                                                            {/*className={classes.textField + " width-full"}*/}
                                                                            {/*value={item.frequency}*/}
                                                                            {/*onChange={e => this.handleChangeMedication(e, 'frequency', index)}*/}
                                                                            {/*margin="normal"*/}
                                                                            {/*/>*/}
                                                                            {/*</GridItem>*/}
                                                                            <GridItem xs={12} sm={3}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Instruction"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.instruction}
                                                                                    onChange={e => this.handleChangeMedication(e, 'instruction', index)}
                                                                                    margin="normal"
                                                                                /></GridItem>
                                                                        </div>
                                                                    })}
                                                                    <GridItem xs={12} sm={6} md={3}>
                                                                        <Button color="warning"
                                                                                onClick={(e) => this.addMedication(e)}>Add
                                                                            Medication
                                                                        </Button></GridItem>
                                                                    <GridItem xs={12} sm={6}>
                                                                    </GridItem>
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        </ExpansionPanel> :
                                                        <ExpansionPanel className="width-full" defaultExpanded>
                                                            <ExpansionPanelSummary
                                                                expandIcon={<ExpandMoreIcon/>}
                                                                aria-controls="panel1a-content"
                                                                id="panel1a-header">
                                                                <Typography
                                                                    className={classes.heading}>Medication</Typography>
                                                            </ExpansionPanelSummary>
                                                            <ExpansionPanelDetails>
                                                                <Typography className="width-full">
                                                                    {this.state.medication.map((item, index) => {
                                                                        return <div
                                                                            className="width-full list-inline displayInline"
                                                                            key={"medication" + index}>
                                                                            <GridItem xs={12} sm={6} md={3}>
                                                                                {/*<TextField*/}
                                                                                {/*required*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Name"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.name}*/}
                                                                                {/*onChange={e => this.handleChangeMedication(e, 'name', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                                <AutoCompleteMedication
                                                                                    clinic_id={this.state.clinic_id}
                                                                                    clinic_master_id={this.state.clinicmaster_id}
                                                                                    name={"Medicine"}
                                                                                    type="Medication"
                                                                                    nameKey="name"
                                                                                    index={index}
                                                                                    id={"Medication" + index}
                                                                                    value={item.name}
                                                                                    addMedication={this.addMedication}
                                                                                    saveMedicationInvestigation={this.saveMedication}
                                                                                    onChange={this.handleChangeMedication}
                                                                                    getSuggestionValue={this.getSuggestionValue}/>
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={4} md={2}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Dosage"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.dosage}
                                                                                    onChange={e => this.handleChangeMedication(e, 'dosage', index)}
                                                                                    margin="normal"
                                                                                /> </GridItem>
                                                                            <GridItem xs={12} sm={2} md={1}
                                                                                      style={{marginTop: '40px'}}>
                                                                                <a href="#"
                                                                                   onClick={() => this.onSelectDurationType('durationType', index)}><span>{this.state.durationType[index]}</span></a>
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={6} md={3}>
                                                                                <NumberFormat
                                                                                    onValueChange={(values) => {
                                                                                        const {formattedValue, value} = values;
                                                                                        // formattedValue = $2,223
                                                                                        // value ie, 2223
                                                                                        this.handleChangeFrequency(formattedValue, 'frequency', index);
                                                                                    }} style={{
                                                                                    marginTop: '40px',
                                                                                    textAlign: 'center',
                                                                                    border: '0',
                                                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.44)'
                                                                                }}
                                                                                    placeholder="0-0-0"
                                                                                    format="#-#-#" mask="_"/>
                                                                                {/*<FormControl*/}
                                                                                {/*className={classes.formControl + " width-full"}*/}
                                                                                {/*style={{marginTop: '15px'}}>*/}
                                                                                {/*<InputLabel*/}
                                                                                {/*htmlFor="frequency">Frequency</InputLabel>*/}
                                                                                {/*<Select*/}
                                                                                {/*value={item.frequency}*/}
                                                                                {/*onChange={e => this.handleChangeMedication(e, 'frequency', index)}*/}
                                                                                {/*inputProps={{*/}
                                                                                {/*name: 'frequency',*/}
                                                                                {/*id: 'frequency',*/}
                                                                                {/*}}>*/}
                                                                                {/*<MenuItem value={"1-0-1"}>twice*/}
                                                                                {/*daily</MenuItem>*/}
                                                                                {/*<MenuItem value={"1-1-1"}>three*/}
                                                                                {/*times a*/}
                                                                                {/*day</MenuItem>*/}
                                                                                {/*<MenuItem value={"1-1-1-1"}>four*/}
                                                                                {/*times a*/}
                                                                                {/*day</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"every four hours"}>every*/}
                                                                                {/*four hours</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"every 2 hours"}>every*/}
                                                                                {/*2 hours</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"every other hour"}>every*/}
                                                                                {/*other hour</MenuItem>*/}
                                                                                {/*<MenuItem value={"every day"}>every*/}
                                                                                {/*day</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"every other day"}>every*/}
                                                                                {/*other day</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"three times a week"}>three*/}
                                                                                {/*times a week</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"immediately"}>immediately</MenuItem>*/}
                                                                                {/*<MenuItem value={"as needed"}>as*/}
                                                                                {/*needed</MenuItem>*/}
                                                                                {/*<MenuItem value={"once a week"}>once*/}
                                                                                {/*a*/}
                                                                                {/*week</MenuItem>*/}
                                                                                {/*<MenuItem*/}
                                                                                {/*value={"twice a week"}>twice*/}
                                                                                {/*a*/}
                                                                                {/*week</MenuItem>*/}
                                                                                {/*</Select>*/}
                                                                                {/*</FormControl>*/}
                                                                                {/*<TextField*/}
                                                                                {/*id="standard-name"*/}
                                                                                {/*label="Frequency"*/}
                                                                                {/*className={classes.textField + " width-full"}*/}
                                                                                {/*value={item.frequency}*/}
                                                                                {/*onChange={e => this.handleChangeMedication(e, 'frequency', index)}*/}
                                                                                {/*margin="normal"*/}
                                                                                {/*/>*/}
                                                                            </GridItem>
                                                                            <GridItem xs={12} sm={6} md={3}>
                                                                                <TextField
                                                                                    id="standard-name"
                                                                                    label="Instruction"
                                                                                    className={classes.textField + " width-full"}
                                                                                    value={item.instruction}
                                                                                    onChange={e => this.handleChangeMedication(e, 'instruction', index)}
                                                                                    margin="normal"
                                                                                /></GridItem>
                                                                        </div>
                                                                    })}
                                                                    <GridItem xs={12} sm={6} md={3}>
                                                                        <Button color="warning"
                                                                                onClick={(e) => this.addMedication(e)}>Add
                                                                            Medication
                                                                        </Button></GridItem>
                                                                    <GridItem xs={12} sm={6}>
                                                                    </GridItem>
                                                                </Typography>
                                                            </ExpansionPanelDetails>
                                                        </ExpansionPanel>
                                                    }
                                                </GridContainer>
                                                <br/>
                                            </GridItem></div>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                <Datetime
                                                    timeFormat={false}
                                                    // defaultValue={new Date()}
                                                    //value={this.state.date}
                                                    name="date"
                                                    id="appointment_date"
                                                    dateFormat={"DD MMMM, YYYY"}
                                                    closeOnSelect={true}
                                                    onChange={event => this.handleChangeDate(event)}
                                                    inputProps={{placeholder: "Follow up Date"}}/>
                                                <br/><br/>
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <TextField
                                                    id="standard-name"
                                                    label="Follow Up Days"
                                                    onChange={event => this.handleChangeDate(event)}
                                                    className={classes.textField + " width-full"}
                                                    margin="normal"
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                {this.state.secondaryNumber.map((name, index) => {
                                                    return <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="simple-select"
                                                            className={classes.selectLabel}>
                                                            Doctor
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={name}
                                                            onChange={event => this.changeSecondaryNumbers(event, "optional", index)}
                                                            inputProps={{name: "doctor_id", id: "secondaryNumber"}}>
                                                            <MenuItem
                                                                disabled={true}
                                                                classes={{
                                                                    root: classes.selectMenuItem,
                                                                    selected: classes.selectMenuItemSelected
                                                                }}>
                                                                Select Doctor
                                                            </MenuItem>
                                                            {this.state.clinicDetail !== null && this.state.clinicDetail.clinic_doctors ? this.state.clinicDetail.clinic_doctors.map(item => {
                                                                return <MenuItem key={Math.random()}
                                                                                 classes={{root: classes.selectMenuItem}}
                                                                                 value={item.user_id.name}>
                                                                    {item.user_id.name}  </MenuItem>
                                                            }) : null}
                                                        </Select>
                                                    </FormControl>
                                                })}
                                                <Button size="lg" color="warning"
                                                        onClick={(e) => this.addSecondaryContact(e)}>Add Doctor
                                                </Button>

                                            </GridItem>

                                            <GridItem xs={12} sm={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.save_template}
                                                            onChange={this.handleChange("save_template")}
                                                            value="save_template"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="Save as template"
                                                />
                                            </GridItem>
                                            {this.state.save_template ? <GridItem xs={12} sm={3}>
                                                <CustomInput
                                                    labelText="Remarks"
                                                    success={this.state.remarksState === "success"}
                                                    error={this.state.remarksState === "error"}
                                                    id="remarks"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "remarks", "novalidation"),
                                                        value: this.state.remarks,

                                                    }}
                                                />
                                            </GridItem> : null}

                                        </GridContainer>

                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning"
                                                    onClick={() => this.handleClickOpen("previewModal")}>
                                                Preview
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <NavLink to={dashboardRouter(`/prescription/readPrescription`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>


                    {this.state.templatesPres.length > 0 ? <Dialog
                        maxWidth="lg"
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.classicModal}
                        TransitionComponent={Transition}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description" keepMounted
                        onClose={() => this.handleClose("classicModal")}>
                        <DialogTitle id="alert-dialog-title">{"Select Prescription Templates"}</DialogTitle>
                        <DialogActions
                            style={{margin: '8px auto', width: '900px', textAlign: 'left', background: '#fff'}}>

                            <GridContainer style={{padding: '20px'}}>
                                <GridItem xs={4}>
                                    <AutoCompletePrescriptionTemplate clinic_id={this.state.clinic_id}
                                                                      clinic_master_id={this.state.clinicmaster_id}
                                                                      setNotesValue={this.setNotesValue}
                                                                      getReportTitleSuggestionValue={this.getReportTitleSuggestionValue}/>

                                </GridItem>
                                <GridItem xs={8}>
                                </GridItem>
                                <Grid item xs={4} style={{height: '400px', overflow: 'scroll'}}>
                                    <List>
                                        {this.state.templatesPres.map((item, index) => {
                                            return <ListItem component="div"
                                                             onClick={() => {
                                                                 this.setState({
                                                                     selectTemplate: index
                                                                 });
                                                                 this.props.saveSearchPrescription(Math.random())
                                                             }}
                                                             style={this.state.selectTemplate === index ? {
                                                                 background: '#39abc1',
                                                                 color: 'white',
                                                                 padding: '10px',
                                                             } : {
                                                                 background: '#fff',
                                                                 color: 'black',
                                                                 padding: '10px',
                                                             }} key={index} divider autoFocus>
                                                {/*<ListItemText
                                                 primary={item.remark !== "" ? item.remark : "No Remark"}
                                                 secondary={item.created_at ? getDateConverter(item.created_at) : ""}
                                                 >*/}
                                                <div style={{padding: "5px"}}>
                                                    <GridContainer key={Math.random()}>
                                                        <GridItem xs={12}>
                                                            <h4>{item.remark !== "" ? item.remark : "No Remark"}</h4>
                                                            <p>{item.created_at ? getDateConverter(item.created_at) : null}</p>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                {/*</ListItemText>*/}
                                            </ListItem>
                                        })}
                                    </List>
                                </Grid>
                                <Grid item xs={8}>
                                    <Card component="div" style={{margin: '10px'}}>
                                        {/*<div style={{padding: "5px 15px"}}> */}
                                        <GridContainer key={Math.random()}>
                                            <GridItem xs={12}>

                                                <GridItem>
                                                    <h4><strong>Clinical Notes</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <b>Complaints:</b>{this.state.templatesPres[this.state.selectTemplate].clinical_notes ? this.state.templatesPres[this.state.selectTemplate].clinical_notes.complaint : ""}<br/>
                                                    <b>
                                                        Observation:</b>{this.state.templatesPres[this.state.selectTemplate].clinical_notes ? this.state.templatesPres[this.state.selectTemplate].clinical_notes.observations : ""}<br/>
                                                    <b>Diagnosis:</b>{this.state.templatesPres[this.state.selectTemplate].clinical_notes ? this.state.templatesPres[this.state.selectTemplate].clinical_notes.diagnosis : ""}
                                                </GridItem>
                                                <GridItem>
                                                    <h4><strong>Investigation</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <div>{this.state.templatesPres[this.state.selectTemplate].investigation.map(item => {
                                                        return <div key={Math.random()}>{item.name}</div>
                                                    })}</div>
                                                </GridItem>
                                                <GridItem>
                                                    <h4><strong>Prescription</strong></h4>
                                                </GridItem>
                                                <GridItem>
                                                    <div>{this.state.templatesPres[this.state.selectTemplate].medicines.map(item => {
                                                        return <div key={Math.random()}>{item.name}</div>
                                                    })}</div>
                                                </GridItem>
                                            </GridItem>
                                        </GridContainer>
                                        {/*</div> */}
                                        <CardFooter>
                                        </CardFooter>
                                    </Card>
                                </Grid>

                            </GridContainer>

                        </DialogActions>
                        <DialogActions style={{margin: '8px auto'}}>

                            <GridContainer> <Button color="warning" onClick={() => {
                                this.setTemplate();
                                this.handleClose("classicModal")
                            }}>
                                Select
                            </Button>
                                <Button
                                    onClick={() => this.handleClose("classicModal")}>
                                    Cancel
                                </Button></GridContainer>
                        </DialogActions>
                    </Dialog> : null}
                    <Dialog
                        maxWidth="lg"
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.previewModal}
                        TransitionComponent={Transition}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description" keepMounted
                        onClose={() => this.handleClose("classicModal")}>
                        <DialogTitle id="alert-dialog-title">{"Preview Prescription"}</DialogTitle>
                        <DialogActions style={{margin: '8px auto', width: '900px', textAlign: 'left'}}>
                            <GridContainer style={{padding: '20px'}}>
                                <Grid item xs={12}>
                                    <GridContainer style={{padding: '20px'}}>
                                        <Grid item xs={12}>
                                            <Card component="div" style={{margin: '10px', padding: '30px'}}>
                                                <div style={{padding: "5px"}}>
                                                    <GridContainer key={Math.random()}>
                                                        <table style={{width: '100%'}}>
                                                            <tr>
                                                                <td style={{textAlign: 'left'}}><h5>
                                                                    <b>{this.state.name}</b></h5></td>
                                                                <td style={{textAlign: 'right'}}><h5><b>
                                                                </b></h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{textAlign: 'left'}}><h5>
                                                                    <b>{this.state.gender}, {this.state.age + " Years"}</b>
                                                                </h5></td>
                                                                <td style={{textAlign: 'right'}}><h5><b>
                                                                </b></h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{textAlign: 'left'}}><h5>
                                                                    <b>Ph: {this.state.autoCompleteValue}</b>
                                                                </h5></td>
                                                                <td style={{textAlign: 'right'}}/>
                                                            </tr>
                                                        </table>
                                                        <hr/>
                                                        <h5>Clinical Notes</h5>
                                                        <table style={{width: '100%'}}>
                                                            <tr>
                                                                <td style={{minWidth: 200, textAlign: 'left'}}><h5>
                                                                    <b>Complaints: </b></h5></td>
                                                                <td style={{textAlign: 'left'}}><h5><b>
                                                                    {this.state.Complaints}
                                                                </b>
                                                                </h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{minWidth: 200, textAlign: 'left'}}><h5>
                                                                    <b>Observation: </b>
                                                                </h5></td>
                                                                <td style={{textAlign: 'left'}}><h5>
                                                                    <b>{this.state.Observation}
                                                                    </b></h5></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{minWidth: 200, textAlign: 'left'}}><h5>
                                                                    <b>Diagnosis: </b>
                                                                </h5></td>
                                                                <td style={{textAlign: 'left'}}>
                                                                    <h5><b>{this.state.Diagnosis}</b></h5>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                        <hr/>
                                                        <h5>Investigation</h5>
                                                        <table style={{width: '100%'}}>
                                                            <tr>
                                                                <td style={{}}><h5>
                                                                    <b>Name:</b></h5></td>
                                                                <td style={{}}><h5><b>
                                                                    Instruction
                                                                </b>
                                                                </h5></td>
                                                            </tr>
                                                            {this.state.investigation.map(item => {
                                                                return <tr key={Math.random()}>
                                                                    <td style={{textAlign: 'left'}}><h5>
                                                                        <b>{item.name}</b>
                                                                    </h5></td>
                                                                    <td style={{textAlign: 'left'}}><h5>
                                                                        <b>{item.instruction}
                                                                        </b></h5></td>
                                                                </tr>
                                                            })}
                                                        </table>
                                                        <hr/>
                                                        <h5>Prescription</h5>
                                                        <table style={{width: '100%'}}>
                                                            <tr>
                                                                <td style={{textAlign: 'left'}}><h5>
                                                                    <b>DRUG</b></h5></td>
                                                                <td style={{textAlign: 'left'}}><h5><b>
                                                                    FREQ</b></h5>
                                                                </td>
                                                                <td style={{textAlign: 'left'}}><h5><b>
                                                                    DURATION</b></h5>
                                                                </td>
                                                                <td style={{textAlign: 'left'}}><h5><b>
                                                                    INSTRUCTIONS</b></h5>
                                                                </td>
                                                            </tr>
                                                            {this.state.medication.map(item => {
                                                                return <tr key={Math.random()}>
                                                                    <td style={{textAlign: 'left'}}><h5>
                                                                        <b>{item.name}</b>
                                                                    </h5></td>
                                                                    <td style={{textAlign: 'left'}}><h5>
                                                                        <b>{item.frequency}
                                                                        </b></h5></td>
                                                                    <td style={{textAlign: 'left'}}><h5>
                                                                        <b>{item.dosage}
                                                                        </b></h5></td>
                                                                    <td style={{textAlign: 'left'}}><h5><b>
                                                                    </b></h5></td>
                                                                </tr>
                                                            })}
                                                        </table>
                                                    </GridContainer>
                                                </div>
                                            </Card>
                                        </Grid>

                                    </GridContainer>
                                </Grid>

                            </GridContainer>
                        </DialogActions>
                        <DialogActions style={{margin: '8px auto'}}>

                            <GridContainer> <Button color="warning" onClick={() => {
                                this.typeClick();
                                this.handleClose("previewModal")
                            }}>
                                Save
                            </Button>
                                <Button
                                    onClick={() => this.handleClose("previewModal")}>
                                    Cancel
                                </Button></GridContainer>
                        </DialogActions>
                    </Dialog>

                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    handleClickOpen(modal) {
        var x = [];
        x[modal] = true;
        this.setState(x);
    }

    handleClose(modal) {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    addInvestigation() {
        let a = [{name: "", instruction: ""}];
        let b = this.state.investigation.concat(a);
        this.setState({investigation: b}, () => {
            document.getElementById("Investigation" + (b.length - 1).toString()).focus();
        });
    }

    handleChangeInvestigation(e, name, index) {
        let a = this.state.investigation.slice(); //creates the clone of the state
        a[index][name] = e.target.value;
        this.setState({investigation: this.state.investigation})
    }

    saveInvestigation(value, type, index) {
        let a = this.state.investigation.slice(); //creates the clone of the state
        a[index][type] = value
        this.setState({investigation: this.state.investigation})

    }

    addMedication() {
        let a = [{name: "", dosage: "", frequency: "", instruction: ""}];
        let b = this.state.medication.concat(a);
        let c = ["days"];
        let d = this.state.durationType.concat(c);
        this.setState({medication: b, durationType: d}, () => {
            document.getElementById("Medication" + (b.length - 1).toString()).focus();
        });
    }


    onSelectDuration(name, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        let newDose = a[index][name];
        let newDosage = newDose.slice(0, 1)
        if (this.state.duration[index] === "days") {
            a[index][name] = newDosage;
            this.state.duration[index] = "weeks"
            this.setState({duration: this.state.duration})
        } else if (this.state.duration[index] === "weeks") {
            a[index][name] = newDosage;
            this.state.duration[index] = "months"
            this.setState({duration: this.state.duration})

        } else {
            a[index][name] = newDosage;
            this.state.duration[index] = "days"
            this.setState({duration: this.state.duration})
        }
    }

    onSelectDurationType(name, index) {
        if (this.state.durationType[index] === "days") {
            this.state.durationType[index] = "weeks";
            this.setState({durationType: this.state.durationType})
        } else if (this.state.durationType[index] === "weeks") {
            this.state.durationType[index] = "months";
            this.setState({durationType: this.state.durationType})
        } else {
            this.state.durationType[index] = "days";
            this.setState({duration: this.state.durationType})
        }
    }

    handleChangeMedication(e, name, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        a[index][name] = e.target.value;
        this.setState({medication: this.state.medication})
    }

    handleChangeFrequency(value, name, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        a[index][name] = value;
        this.setState({medication: this.state.medication})
    }

    saveMedication(value, type, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        a[index][type] = value
        this.setState({medication: this.state.medication})

    }

    addSecondaryContact() {
        let a = [""];
        let b = this.state.secondaryNumber.concat(a);
        this.setState({secondaryNumber: b})
    }

    handleChangeSecondayNumber(e, index) {
        this.state.secondaryNumber[index] = e.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber})
    }

    changeSecondaryNumbers(event, inputType, index) {
        let a = this.state.secondaryNumber.slice(); //creates the clone of the state
        a[index] = event.target.value;
        this.state.secondaryNumber[index] = event.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber});
        if ((event.target.value)) {
            let state = this.state;
            this.state.secondaryNumberState[index] = "success";
            this.setState(state);
        } else if (event.target.value === "" && inputType === "optional") {
            let state = this.state;
            this.state.secondaryNumberState[index] = "none";
            this.setState(state);
        } else {
            let state = this.state;
            this.state.secondaryNumberState[index] = "error";
            this.setState(state);
        }
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.clinic_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic!", color: "danger"});

        } else if (this.state.clickedId === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.clinicmaster_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic master!", color: "danger"});

        } else if (this.state.name === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.secondaryNumber.length === 0) {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the doctor!", color: "danger"});

        } else if (this.state.clinic_id !== "" && this.state.name && this.state.autoCompleteValue && this.state.clinicmaster_id && this.state.secondaryNumber.length > 0) {
            var data = {
                "clinic_master_id": this.state.clinicmaster_id,
                "clinic_id": this.state.clinic_id,
                "patient_id": this.state.clickedId,
                "user_id": this.state.clickedId,
                "doctor_id": "",
                "medicines": this.state.medication.map((item, index) => {
                    return {
                        name: item.name,
                        dosage: item.dosage + " " + this.state.durationType[index],
                        frequency: item.frequency,
                        instruction: item.instruction
                    }
                }),
                "investigation": this.state.investigation,
                "paid": this.state.checkedA,
                "name": this.state.name,
                "contact": this.state.autoCompleteValue,
                "email": this.state.email,
                "ref_by": this.state.ref_by,
                "remark": this.state.remarks,
                "save_template": this.state.save_template,
                "clinical_notes": {
                    "complaint": (this.state.Complaints.filter(a => a !== "")).map(b => " " + b).toString(),
                    "observations": (this.state.Observation.filter(a => a !== "")).map(b => " " + b).toString(),
                    "diagnosis": (this.state.Diagnosis.filter(a => a !== "")).map(b => " " + b).toString(),
                    "vitals": {
                        "pulse": this.state.pulse,
                        "weight": this.state.weight,
                        "bloodPressure": this.state.bloodPressure,
                        "temperature": this.state.temperature,
                        "rate": this.state.rate
                    }
                },
                "follow_up_date": this.state.followupDate,
                "date": currentDate(),
                "docs": this.state.secondaryNumber.filter(function (value, index, arr) {
                    return value !== "";
                }).map(item => {
                    return {
                        "sign": this.state.clinicDetail.clinic_doctors.filter(a => a.user_id.name === item)[0].clinics.filter(b => b.clinic_id === this.state.clinic_id)[0].signature ? this.state.clinicDetail.clinic_doctors.filter(a => a.user_id.name === item)[0].clinics.filter(b => b.clinic_id === this.state.clinic_id)[0].signature : "Doctor",
                        "name": item
                    }
                })
            };

            api.createPrescription(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Prescription Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.setState();
                    this.props.id.history.push(dashboardRouter(`/prescription/view/${json.data.data._id}`));
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics}, () => {

            })
        });
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

}

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    saveSearchPrescription
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(validationFormsStyle)(CreatePrescription));



// WEBPACK FOOTER //
// ./src/components/Prescription/createPrescription.jsx